module.exports = __webpack_public_path__ + "img/other.4472abf.svg";